import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import {
    GenericCameraSettings,
    GenericCameraSettingsChild,
    InputType,
    CameraSettingsErrorStateMatcher,
    RenderType
} from '@pages/camera-settings/models';

@Component({
    selector: 'mat-generic-form-field',
    templateUrl: './mat-generic-form-field.component.html',
    styleUrls: ['./mat-generic-form-field.component.scss']
})
export class MatGenericFormFieldComponent implements OnInit {
    @Input() property: GenericCameraSettings;
    @Input() form!: FormGroup;
    @Output() onChange = new EventEmitter<any>();
    options: any;
    get isValid() {
        try {
            if (this.form) {
                return this.form.controls[this.property.propertyName]?.valid;
            } else {
                return false;
            }
        } catch (e) {
            console.error(this.property.propertyName);
            throw e;
        }
    }
    Error(err: string) {
        if (this.form && this.form.controls[this.property.propertyName]?.errors) {
            return this.form.controls[this.property.propertyName]?.errors[err];
        } else {
            return null;
        }
    }
    childProperties: GenericCameraSettingsChild[] = [];
    public get RenderType(): typeof RenderType {
        return RenderType;
    }
    public get InputType(): typeof InputType {
        return InputType;
    }
    constructor() { }
    matcher = new CameraSettingsErrorStateMatcher();
    ngOnInit(): void {
        if (this.property.renderType == RenderType.Slider) {
            this.options = {
                floor: this.property.min,
                ceil: this.property.max,
                showTicks: true,
            }
        }
    }
    ngOnChanges() {
        if (this.property.disabled) {
            this.form.controls[this.property.propertyName]?.disable();
        } else {
            this.form.controls[this.property.propertyName]?.enable();
        }
    }
    ngAfterViewInit() { }

    textBoxUpdate($event: any) {
        this.property.value = $event.target.value;
        this.onChange.next($event.target.value);
    }
    dropdownUpdate($event: MatSelectChange) {
        this.property.value = $event.value;
        this.onChange.next($event.value);
    }
    toggleUpdate($event: MatSlideToggleChange) {
        this.property.value = $event.checked;
        this.onChange.next($event.checked);
    }
    checkBoxUpdate($event: any) {
        this.property.value = $event.checked;
        this.onChange.next($event.checked);
    }
}
